import { Input, InputPassword, TagInput } from '@atom/form/input/input';
import { FormSwitcher } from '@component/form-switcher/form-switcher';
import { Form } from '@form/common.style';
import { FormError } from '@form/form-error';
import { BaseFormInterface } from '@interface/form/base-form.interface';

import { TextBlock, Wrapper } from './integration-base.style';

interface IntegrationBaseFormProps extends BaseFormInterface {
  onEnable: (enabled: boolean) => void;
}

export const IntegrationBaseForm = ({ form, fields, onEnable, error }: IntegrationBaseFormProps) => (
  <Form form={form} layout='vertical' name='integration'>
    {fields?.map((field) => (
      <Wrapper key={field.label}>
        <Form.Item label={field.label} name={field.name} rules={[{ required: true }]}>
          {field.multiple ? (
            <TagInput placeholder={field.placeholder} />
          ) : field.type === 'password' ? (
            <InputPassword placeholder={field.placeholder} />
          ) : field.type === 'velory' ? (
            <Input placeholder={field.placeholder} />
          ) : (
            <Input placeholder={field.placeholder} />
          )}
        </Form.Item>
        {field.type === 'velory' && <TextBlock>.velory.com</TextBlock>}
      </Wrapper>
    ))}
    <Form.Item label='Enable' name='enabled' rules={[{ required: true }]}>
      <FormSwitcher form={form} name='enabled' onChange={onEnable} />
    </Form.Item>
    <FormError error={error} errorField='' />
  </Form>
);
